



































































































import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation, Getter } from "vuex-class";
import Auth from "@aws-amplify/auth";

@Component
export default class SignIn extends Vue {
  @Getter("auth/signedIn") public signedIn: boolean;

  @Mutation("auth/setCognitoUser")
  public setCognitoUser: (user: any) => void;

  @Mutation("app/addRequest")
  public addRequest: (id: string) => void;

  @Mutation("app/removeRequest")
  public removeRequest: (id: string) => void;

  @Mutation("app/setShowsidebar")
  public setShowsidebar: (value: boolean) => void;

  public username: string = "";
  public password: string = "";
  public showPassword: boolean = false;

  public currentyear: number = new Date().getFullYear();

  /**
   * @see https://aws-amplify.github.io/docs/js/authentication
   */
  public async signIn() {
    try {
      this.addRequest("signIn");

      const user = await Auth.signIn(this.username, this.password);

      this.setCognitoUser(user);

      if (
        user.challengeName === "SMS_MFA" ||
        user.challengeName === "SOFTWARE_TOKEN_MFA"
      ) {
        // Confirm your email (or mobile, if SMS_MFA is implemented)
        this.$router.push({ name: "confirm-email" });
      } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
        // Choose a new password
        this.$router.push({ name: "complete-new-password" });
      } else {
        this.setShowsidebar(true);

        // Check if we are allowed to access the CMS (if Cognito Group includes "Administrators" or "Customers")
        const assignedGroups = _.get(
          user,
          'signInUserSession.accessToken.payload["cognito:groups"]',
          []
        );
        const isAllowedAccess = assignedGroups.some((assignedGroup: string) =>
          ["Administrators","Contractors","BaseUser","AdvanceUser","Inspectors"].includes(assignedGroup)
        );
        if (isAllowedAccess) {
          this.$router.push({ name: "maintenancejobs" });
        } else {
          await Auth.signOut();
          this.setCognitoUser(null);
          throw Error(
            "You do not have the required permissions to access this system. Please contact support to arrange access."
          );
        }
      }
    } catch (err) {
      if (err.code === "UserNotConfirmedException") {
        // The error happens if the user didn't finish the confirmation step when signing up
        // In this case you need to resend the code and confirm the user
        // About how to resend the code and confirm the user, please check the signUp part
        this.$onecentral.displayError(err);
      } else if (err.code === "PasswordResetRequiredException") {
        // The error happens when the password is reset in the Cognito console
        // In this case you need to call forgotPassword to reset the password
        // Please check the Forgot Password part.
        this.$onecentral.displayError(err);
        this.resetPassword();
      } else if (
        err.code === "NotAuthorizedException" ||
        err.code === "UserNotFoundException"
      ) {
        // The error happens when the incorrect password is provided
        // or when the supplied username/email does not exist in the Cognito user pool
        this.$onecentral.displayError("Invalid login details");
      } else if (typeof err.message === "string" && err.message.length) {
        this.$onecentral.displayError(err);
      } else {
        this.$onecentral.displayError(
          "An unexpected error occurred, please try again later."
        );
      }
    } finally {
      this.removeRequest("signIn");
    }
  }

  public resetPassword() {
    this.$router.push({ name: "reset-password" });
  }

  public toggleShow() {
    this.showPassword = !this.showPassword;
  }
}
